export type FacultyKey =
    | 'ikss'
    | 'itpi'
    | 'kb'
    | 'sted'
    | 'rsr'
    | 'im'
    | 'kt'
    | 'vuc'
    | 'studsovet';

const GRADIENT_VAR: Record<FacultyKey, string> = {
    ikss: '--rd-grad-ikss',
    itpi: '--rd-grad-itpi',
    kb: '--rd-grad-kb',
    sted: '--rd-grad-sted',
    rsr: '--rd-grad-rsr',
    im: '--rd-grad-im',
    kt: '--rd-grad-kt',
    vuc: '--rd-grad-vuc',
    studsovet: '--rd-grad-studsovet',
};
export const FACULTY_TITLE: Record<FacultyKey, string> = {
    ikss: 'Факультет ИКСС',
    itpi: 'Факультет ИТПИ',
    kb: 'Факультет КБ',
    sted: 'Факультет СТЭД',
    rsr: 'Факультет РСР',
    im: 'Институт магистратуры',
    kt: 'Колледж телекоммуникаций',
    vuc: 'Военный учебный центр',
    studsovet: 'Студенческий совет СПбГУТ',
};

const MATCHERS: { key: FacultyKey; needles: string[] }[] = [
    { key: 'ikss', needles: ['иксс'] },
    { key: 'itpi', needles: ['итпи'] },
    { key: 'kb', needles: ['кб', 'кибербезопас'] },
    { key: 'sted', needles: ['стэд'] },
    { key: 'rsr', needles: ['рср'] },
    { key: 'im', needles: ['институт магистратуры', 'магистратур', 'им'] },
    { key: 'kt', needles: ['колледж телекоммуникац', 'кт', 'спбкт'] },
    { key: 'vuc', needles: ['военный учебный центр', 'вуц'] },
    { key: 'studsovet', needles: ['спбгут', 'студенческий совет', 'общие'] },
];

function normalize(raw: string): string {
    return raw.toLowerCase().replace(/ё/g, 'е').trim();
}
const NEEDLES_SORTED = MATCHERS.reduce(
    (acc: { key: FacultyKey; needle: string }[], matcher) =>
        acc.concat(
            matcher.needles.map(needle => ({ key: matcher.key, needle }))
        ),
    []
).sort((a, b) => b.needle.length - a.needle.length);

function needleRe(needle: string): RegExp {
    return needle.length >= 4
        ? new RegExp(needle)
        : new RegExp(`(^|[^а-я])${needle}([^а-я]|$)`);
}
export function resolveFacultyKey(
    ...names: (string | undefined)[]
): FacultyKey | undefined {
    const candidates = names
        .filter((n): n is string => Boolean(n))
        .map(normalize);
    const hit = NEEDLES_SORTED.filter(entry =>
        candidates.some(value => needleRe(entry.needle).test(value))
    )[0];
    return hit ? hit.key : undefined;
}
export function facultyGradient(key: FacultyKey | undefined): string {
    if (!key) return 'var(--rd-grad-neutral)';
    return `var(${GRADIENT_VAR[key]})`;
}
export function facultyTitle(...names: (string | undefined)[]): string {
    const key = resolveFacultyKey(...names);
    if (key) return FACULTY_TITLE[key];
    return names.filter(Boolean)[0] || 'Подразделение';
}

const warned: { [label: string]: true } = {};
export function facultyGradientByName(
    ...names: (string | undefined)[]
): string {
    const key = resolveFacultyKey(...names);
    if (!key) {
        const label = names.filter(Boolean).join(' / ') || '(без названия)';
        if (process.env.NODE_ENV === 'development' && !warned[label]) {
            warned[label] = true;
            // eslint-disable-next-line no-console
            console.warn(
                `[faculties] нет цвета для подразделения «${label}», ` +
                    'карточка нейтральная — добавь ключ ' +
                    'в src/theme/faculties.ts'
            );
        }
    }
    return facultyGradient(key);
}
